<script setup lang="ts">
import RedBell from "@/shared/components/atomic/svgs/red-bell/RedBell.vue";

defineProps<{
    pendingRegistrationUserCount: number;
}>();
</script>

<template>
    <div
        class="flex gap-3 justify-center items-center transition-all duration-200 cursor-pointer size-fit p-xsmall bg-surface-primary-subtler rounded-small1 hover:bg-surface-primary-subtler/70 active:bg-surface-danger-subtler active:scale-98 pulse-shadow"
    >
        <RedBell />
        <p class="font-normal text-body-medium font-pretendard text-t-basic">
            새로운 <span class="font-bold">등원신청</span> 이
            <span class="font-bold text-primary-red">{{ pendingRegistrationUserCount }}건</span>
            있어요!
        </p>
    </div>
</template>

<style scoped>
.pulse-shadow {
    animation: shadow-pulse 1s infinite;
}

@keyframes shadow-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 205, 208, 0.6);
    }
    50% {
        box-shadow: 0 0 0 4px rgba(255, 205, 208, 0.3);
    }
    100% {
        box-shadow: 0 0 0 7px rgba(255, 205, 208, 0);
    }
}
</style>
